import {
  BreakdownContainer,
  CarContainer,
  CarNotFoundContainer,
  EmissionsContainer,
  EnergyContainer,
  HeatingContainer,
  HowToWithLoopContainer,
  InteractiveContainer,
  IntroContainer,
  NotFoundContainer,
} from './NetZero';
import { Navigate, Route, Routes } from 'react-router';

import OnboardingLayout from '../ui/Layout/OnboardingLayout';
import { usePersistedState } from '../hooks';
import { useState } from 'react';

const NetZeroContainer = () => {
  const [heatingMethod, setHeatingMethod] = usePersistedState(
    'heating-method',
    undefined,
  );
  const [usage, setUsage] = usePersistedState('usage', {
    bedroomCount: '',
    electricityUsage: '',
    heatingUsage: '',
  });
  const [cars, setCars] = usePersistedState('cars', []);
  const [carError, setCarError] = usePersistedState('car-error', undefined);
  const [showGetStarted, setShowGetStarted] = useState(false);
  const sharedProps = {
    heatingMethod,
    setHeatingMethod,
    usage,
    setUsage,
    cars,
    setCars,
    carError,
    setCarError,
    setShowGetStarted,
  };
  return (
    <OnboardingLayout
      backgroundTint="green"
      showGetStarted={showGetStarted}
      hideSupport
      showNetZeroSupport>
      <Routes>
        <Route path="" element={<IntroContainer />} />
        <Route path="heating" element={<HeatingContainer {...sharedProps} />} />
        <Route path="energy" element={<EnergyContainer {...sharedProps} />} />
        <Route path="car" element={<CarContainer {...sharedProps} />} />
        <Route
          path="car-not-found"
          element={<CarNotFoundContainer {...sharedProps} />}
        />
        <Route
          path="emissions"
          element={<EmissionsContainer {...sharedProps} />}
        />
        <Route
          path="how-to-with-loop"
          element={<HowToWithLoopContainer {...sharedProps} />}
        />
        <Route
          path="breakdown"
          element={<BreakdownContainer {...sharedProps} />}
        />
        <Route
          path="interactive"
          element={<InteractiveContainer {...sharedProps} />}
        />
        <Route path="not-found" element={<NotFoundContainer />} />
        <Route
          path="*"
          element={<Navigate to="/net-zero/not-found" replace />}
        />
      </Routes>
    </OnboardingLayout>
  );
};

NetZeroContainer.propTypes = {};

export default NetZeroContainer;
